import { TableCell, TableHead, TableRow, TableSortLabel, Tooltip } from "@material-ui/core"
import CloseIcon from "@material-ui/icons/Close"

const AssetListHd = ({ sort, sort_by, createSortHandler }) => {
	const savedSorting = JSON.parse(localStorage.getItem('sortField') || '{}')

	const sortableCell = (key, label, width) => (
		<TableCell key={`${key}-${label}`} style={width ? { minWidth: width } : {}}>
			<TableSortLabel
				active={sort === key}
				direction={sort === key && sort_by ? sort_by : 'asc'}
				onClick={() => createSortHandler(key)}
			>
				{label}
			</TableSortLabel>
			{savedSorting?.sort === key && (
				<Tooltip title="Clear" arrow placement="top">
					<CloseIcon
						style={{ fontSize: '15px', color: "#6d9bb9", verticalAlign: 'middle' }}
						size="small"
						className="close-icon"
						onClick={() => createSortHandler('', true)}
					/>
				</Tooltip>
			)}
		</TableCell>
	)

	return (
		<TableHead className="mui-table">
			<TableRow>
				{sortableCell('asset_name', 'Type and Model', 120)}
				{sortableCell('asset_name', 'Serial Number', 120)}
				{sortableCell('current_registration_number', 'Registration Number', 150)}
				{sortableCell('lessor', 'Lessor', 120)}
				{sortableCell('owner', 'Owner', 120)}
				{sortableCell('location', 'Location', 110)}
				{sortableCell('status', 'Lease Status', 110)}
				<TableCell style={{ minWidth: 40 }}>Action</TableCell>
			</TableRow>
		</TableHead>
	)
}

export default AssetListHd
